import React from 'react';

const TopTasksTable = ({ tasks = [] }) => {
  if (!tasks.length) {
    return <p className="text-sm text-gray-500 py-6">No active tasks in this range.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500 border-b">
            <th className="py-2 pr-4">Task</th>
            <th className="py-2 pr-4">Status</th>
            <th className="py-2 pr-4">Due Date</th>
            <th className="py-2 pr-4">Last Update</th>
            <th className="py-2 text-right">Hours</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => (
            <tr key={task.id} className="border-b last:border-0">
              <td className="py-2 pr-4 text-gray-900 max-w-xs whitespace-normal break-words">{task.title}</td>
              <td className="py-2 pr-4">{task.status}</td>
              <td className="py-2 pr-4">{task.dueDate || '-'}</td>
              <td className="py-2 pr-4">{task.lastUpdateDate || '-'}</td>
              <td className="py-2 text-right">{task.hoursLogged.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TopTasksTable;
